module.exports = __webpack_public_path__ + "img/image-7.89fc8c69.jpg";